import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import AboutMe from './components/AboutMe';
import Blog from './components/Blog';
import BlogPost from './components/BlogPost';
import Resume from './components/Resume';
import Photography from './components/Photography';
import Footer from './components/Footer';

function AppContent() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<'about' | 'blog' | 'photography' | 'resume'>('about');

  // Update active tab based on current route
  React.useEffect(() => {
    if (location.pathname === '/' || location.pathname === '/about') {
      setActiveTab('about');
    } else if (location.pathname.startsWith('/blog')) {
      setActiveTab('blog');
    } else if (location.pathname === '/photography') {
      setActiveTab('photography');
    } else if (location.pathname === '/resume') {
      setActiveTab('resume');
    }
  }, [location.pathname]);

  return (
    <div className="App">
      <Navbar activeTab={activeTab} setActiveTab={setActiveTab} />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<AboutMe />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/photography" element={<Photography />} />
          <Route path="/resume" element={<Resume />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
